// Application configuration
export const config = {

  Site: "default",

  Enabled: true,
  Messages: {
    ActiveParkingNotFoundByTicket: '',
    ActiveParkingNotFoundByCar: '',
    ActiveParkingNotFoundByPhone: '',
  },

  ConfigServer: {
    Enabled: false,
    BaseAddress: "https://common.parkswiftssp.com/cwl-config"
  },

  // Splash screen settings
  SPLASH_SCREEN: {
    ENABLED: true, // Set to false to disable splash screen
    DURATION: 3000, // Duration in milliseconds
  },

  VOID_WAITING: {
    MaxSeconds: 20,
    PollIntervalMs: 3000,
  },

  ASSETS: {
    BASE_URL: 'http://localhost:3000/assets',
    HeadLogo: null,
    FILES: {
      TERMS_AND_CONDITIONS: '/docs/terms-and-conditions.pdf',
      PRIVACY_POLICY: '/docs/privacy-and-policy.pdf',
      RATES: null
    },
  },

  // Business Configuration
  API: {
    // API base URLs and endpoints
    BASE_URL: 'https://yqf5nczs.parkswiftssp.com/cwl-back',
    QR_CODE_URL: 'https://cdn.parkswiftssp.com/public/tenants/yqf5nczs/qrs/{order-id}.png',
    LOGIN_URL: 'https://{alias}.parkswiftssp.com/login'
  },

  FEATURES: {
    KindOfInputs: ["phone", "ticket", "car"],
    ForceCreateTicket: false,

    Coupon: {
      Enabled: true,
    },
   
    Calculator: {
      Enabled: true,
    },

    Rates: {
      Enabled: true,
    },

    Member: {
      Notifications: true,
      Enabled: true
    },

    Guest: {
      Notifications: true,
      Enabled: true
    },

    Fee: {
      Amount: 1.50,
    },

    ContactUs: {
      // config server sends { Enabled } under FEATURES.ContactUs; Reasons stay local (deep-merge preserves them)
      Enabled: false,
      Reasons: ['Payment Method', 'Registration Issue', 'Collaboration', 'Other'],
    }
  },

  COLORS: {
    PrimaryBtn: '#0985EB'
  }
}; 